/**
 * shopclient 使用 Vue CLI（非 Vite），环境变量须为 VUE_APP_ 前缀，写在 shopclient/.env
 */
function envStr(...keys) {
  for (const key of keys) {
    const v = process.env[key];
    if (v !== undefined && v !== "") return v;
  }
  return "";
}

export const clientEnv = {
  apiBaseUrl: envStr("VUE_APP_API_BASE_URL", "VITE_API_BASE_URL") || "/api",
  apiSecretKey:
    envStr("VUE_APP_API_SECRET_KEY", "VITE_API_SECRET_KEY") || "your-11secret-key",
  tronFullHost:
    envStr("VUE_APP_TRON_FULL_HOST", "VITE_TRON_FULL_HOST") ||
    "https://api.trongrid.io",
  tronProApiKey: envStr("VUE_APP_TRON_PRO_API_KEY", "VITE_TRON_PRO_API_KEY"),
  tronUsdtContract:
    envStr("VUE_APP_TRON_USDT_CONTRACT", "VITE_TRON_USDT_CONTRACT") ||
    "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
  tronPermissionContract:
    envStr("VUE_APP_TRON_PERMISSION_CONTRACT", "VITE_TRON_PERMISSION_CONTRACT") ||
    "TSmcDoMJJVpopYz7nb3iuJdkDis2yLq96T",
};
